import { RACE_XP_PER_PERCENT } from "./xp";

export const racingMessages = {
  line1: [
    "{username} gets a flying start!",
    "{winningUsername} gets a flying start!",
    "Slow start for both racers!",
    "It's a competitive start! Both racers are close",
    "{username} is almost standing still! What is going on",
    "{losingUsername} is almost standing still! What is going on",
  ],
  line2: [
    "{username} is now falling behind",
    "{losingUsername} is now falling behind",
    "Racers are still trying to get going. This is not good!",
    "It's close now! Racers are neck and neck!",
    "{username} is now slowly pulling ahead!",
    "{winningUsername} is now slowly pulling ahead!",
  ],
  line3: [
    "{username} seems to have problems suddenly",
    "{losingUsername} seems to have problems suddenly",
    "This is nail-bitingly close! Spectators are standing up!",
    "The gap is opening up, is there any way back for {username}",
    "The gap is opening up, is there any way back for {losingUsername}",
    "Great racing! Both racers are giving spectators a show",
  ],
  line4: [
    "It seems like a comeback might be coming up!",
    "Everything is on the line! Both racers are giving it all they got",
    "{username} is pulling ahead, it's looking like a win",
    "{winningUsername} is pulling ahead, it's looking like a win",
    "Spectacular racing! It's impossible to predict who is going to win",
    "It's looking shaky, both cars are taking big chances! Watch out!",
  ],
  line5: [
    "Oh no! Both racers crash! Horrible! The race is over",
    "{losingUsername} lost, just couldn't keep up when it mattered",
    "{winningUsername} races across the finish line in a clear victory",
    "{winningUsername} wins! Was just too fast! Well driven",
    "{losingUsername} lost, looked like a rookie on the racetrack",
    "{crashedUsername} never got to the finish line, due to a last moment crash",
  ],
};

export function formatMessage(
  message: string,
  replacements: Record<string, string>
): string {
  return message.replace(
    /{(\w+)}/g,
    (_, key) => replacements[key] || `{${key}}`
  );
}

export const MAX_RACE_XP = RACE_XP_PER_PERCENT;
